import { Droplets, Thermometer } from 'lucide-react';
import { useEnvironment } from '../../../hooks/useEnvironment';
import { EnvironmentChip } from './EnvironmentChip';
import { ClockChip } from './ClockChip';

/** Ambient temperature / humidity / clock cluster on the right side of the topbar — hidden on narrow screens. */
export function EnvironmentChips() {
  const { data } = useEnvironment();

  return (
    <div className="hidden items-center gap-5 lg:flex">
      <EnvironmentChip icon={<Thermometer size={16} />} value={data ? `${data.ambientTempC}°C` : '—'} label="Ambient" />
      <EnvironmentChip icon={<Droplets size={16} />} value={data ? `${data.humidityPct}%` : '—'} label="Humidity" />
      <ClockChip />
    </div>
  );
}
